import Card2 from "../body/card2";
import FounderNote from "./founderNote";
import "./index.css"
import TeamSection from "./teammember";
import { useNavigate } from "react-router-dom";
const Section1AboutUs = () => {
    const navigate = useNavigate();
    const services = [
        { src: './1.jpg', alt: 'Service 1', className: "margin-top-apply" },
        { src: './2.jpg', alt: 'Service 2', className: "" },
        { src: './3.jpg', alt: 'Service 3', className: "margin-top-apply" },
        { src: './5.jpg', alt: 'Service 4', className: "" }
    ];
    return (
        <div className="container-background-about-us">
            <div className="container  container-margin-top">
                {/* Main Text Section */}
                <div className="text-center mb-5 main-text-wrapper">
                    <h1 className="fw-bold text-main-about-us">
                        Comfortable & Reliable Paying Guest Living
                    </h1>
                    <p className="text-section-about-us">
                        At our core, we provide safe, clean, and fully-equipped paying guest accommodations designed for
                        students and working professionals. Whether you’re looking for a short stay or a long-term home,
                        we’re here to offer comfort, convenience, and peace of mind.
                    </p>
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <button
                            onClick={() => navigate("/contactUs")}
                            className="btn btn-about-us btn-white-background2"
                        >
                            Enquire Now
                        </button>
                        <button
                            className="btn btn-danger btn-about-us-2 btn-red-background"
                            onClick={() => navigate("/contactUs")}
                        >
                            Book a Visit
                        </button>
                    </div>
                </div>


                {/* Service Cards */}
                <div className="row g-4 service-wrapper">
                    {services.map((service, index) => (
                        <div key={index} className={`col-12 col-sm-6 col-lg-3 ${service.className}`}>
                            {/* <div className={`service-card h-100 border-0 shadow ${service.className}`}> */}
                            <img src={service.src} alt={service.alt} className="card-img-top" />

                            {/* </div> */}
                        </div>
                    ))}
                </div>
            </div>
            <section>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>
            <FounderNote />
            <section>
                <div className="image-container">
                    <img src="./polygun.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>
            <TeamSection />
            <div style={{ marginBottom: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Card2 />
            </div>
            <section>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>
        </div>
    )
}

export default Section1AboutUs